import React from "react";
import { useTranslation } from "react-i18next";
import { getStrTime } from "../utils/utils";

import '../style/components/countdown.css';

/**
 * Render an HTML object to display the count down timer in the waiting line. 
 * @param text : text translated which is displayed before the rank
 * @param waitingTime: time to wait ( in openIn use case )
 * @param className: classname of HTML field displayed
 * @param {} param0 
 */
export default function NeoCountDown({ wording={}, className='', waitingTime, onLeave=()=>{}, canLeave=false }) {
    let [time, setTime] = React.useState(0);
    let [strTime, setStrTime] = React.useState("");
    const { t } = useTranslation();

    /**
     * Function to decrease Timer each 1 sec
     */
    const descTimer = React.useCallback(() => {
        let newTime = time - 1000;

        if (newTime >= 0) {
            setStrTime(getStrTime(newTime, t));
            return setTime(newTime);
        }

        setStrTime('...');
        return setTime(0);
    }, [time, t]);

    React.useEffect(() => {
        if (time <= 0) {
            return;
        }
        const timer = setTimeout(() => descTimer(), 1000);
        // do not decrease anymore when time = 0
        return () => clearTimeout(timer);
    }, [time, descTimer]);

    React.useEffect(() => {
        if (waitingTime) {
            setTime(waitingTime);
        }
    }, [waitingTime]);

    if (!waitingTime) {
        return null;
    }

    const { count_down: countdownText, leave_queue } = wording;

    return (
        <div className={className}>
            {countdownText}<span className='queue-waiting-time-count-down'>{strTime}</span>
            {/* TODO: add this as a standalone component to allow leaving from any step */}
            {canLeave && <span className="queue-leaving" onClick={onLeave}>{leave_queue}</span>}
        </div>
    )
}

export function NeoCountDownSeconds({ config: { countdown }, wording, className='', onLeave, canLeave }) {
    let time = Math.ceil(countdown * 1000);
    return <NeoCountDown className={`${className} inline-countdown`} wording={wording} waitingTime={time} onLeave={onLeave} canLeave={canLeave}/>
}
